import n from "react";
function o() {
  const [t, e] = n.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function i() {
    e({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return n.useEffect(() => (e({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", i), () => {
    window.removeEventListener("resize", i);
  }), []), t;
}
export {
  o as useWindowSize
};
